"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalStyles = void 0;

var _styledComponents = require("styled-components");

var _styledNormalize = _interopRequireDefault(require("styled-normalize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Module dependencies.
 */

/**
 * Export `globalStyles`.
 */
var globalStyles = (0, _styledComponents.css)(["", " *{box-sizing:border-box;}body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;}ul{list-style-type:none;margin:0;padding:0;}b,strong{font-weight:700;}:-webkit-autofill,:-webkit-autofill:hover,:-webkit-autofill:focus,:-webkit-autofill:active{transition:color 9999s ease-out,background-color 9999s ease-out;transition-delay:9999s;}"], _styledNormalize.default);
exports.globalStyles = globalStyles;